<!--
 * @Description: 天眼查搜索客户组件
-->
<template>
  <CosViewInput v-if="view" :value="modelValue"/>
  <div style="display: flex; align-content: center" v-else>
    <a-auto-complete
      class="input"
      :placeholder="placeholderSearch"
      v-model:value.trim="modelValue"
      :showSearch="true"
      @search="handleSearch"
      :fieldNames="{ label: 'customerName', value: 'customerName' }"
      :filter-option="false"
      allowClear
      @select="onSelect"
      :options="customerEnum"
    >
      <template #option="item">
        <div v-if="item.value!=='more'" :style="{display:'flex',justifyContent:'space-between',alignItems:'center'}">
          <div :style="{textOverflow:'ellipsis',overflow:'hidden',width:'80%'}">
            <span :style="{ fontWeight: 'bold',fontSize:'15px' }"
                  v-html="highlightMatch( item.customerName, searchValue)"></span>
            <p :style="{ fontSize:'13px',color:'#AAAAAA'}">{{
                `法人：${item.legalPersonName} 经营状态：${item.regStatus}`
              }}</p>
          </div>
          <div :style="{display:'flex'}">
            <!--          <div v-if="item.cosExists"-->
            <!--               :style="{backgroundColor:'red',alignItems:'right',color:'white',borderRadius:'5px',paddingLeft:'4px',paddingRight:'4px',marginRight:'3px'}">-->
            <!--            重复-->
            <!--          </div>-->
            <p v-if="item.cosExists" :style="{
            height:'22px',
            fontSize:'12px',
            lineHeight:'22px',
            backgroundColor:'rgba(223, 68, 59, 0.1)',
            alignItems:'right',
            color:'#df443b',
            borderRadius:'15px',
            paddingLeft:'5px',
            paddingRight:'5px',
            marginRight:'4px',
            textAlign:'center'
          }">重复</p>
            <div :style="{
            height:'22px',
            fontSize:'12px',
            lineHeight:'22px',
            alignItems:'right',
            color:'#1d4cd2',
            backgroundColor:'rgba(29,76,210,0.1)',
            borderRadius:'15px',
            paddingLeft:'5px',
            paddingRight:'5px',
            textAlign:'center'
          }">
              认证
            </div>
          </div>
        </div>
        <template v-if="item.value==='more'">
          <p @click.stop.prevent @click="moreAction" :style="{paddingTop:'5px',paddingBottom:'5px'}">更多...</p>
        </template>
      </template>
    </a-auto-complete>
    <CustomerInfoParse v-if="needParse" @success="parseCustomerInfo"></CustomerInfoParse>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVModel, useDebounceFn } from '@vueuse/core'
import CosViewInput from '@/components/Antd/CosView/input.vue'
import { getTianyanchaCustomerList as tycCustomerListFbu } from '@/api/gucangSales/customerCenter'
import { getTianyanchaCustomerList as tycCustomerListLbu } from '@/api/yuntuSales/customerCenter'
import { SelectProps } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import CustomerInfoParse from '@/components/customerInfoParse/index.vue'

const { t } = useI18n()
const getCustomerMethod = {
  cos_fbu: tycCustomerListFbu,
  cos_lbu: tycCustomerListLbu
}
const props = defineProps<{
  appId: 'cos_fbu' | 'cos_lbu'
  value?: string
  label?: string
  disabled?: boolean
  view?: boolean
  needParse?: boolean
}>()
const customerEnum = ref<any[]>([]) // 客户下拉选择框数据
const searchValue = ref<string>('') // 搜索框值
const emit = defineEmits(['update:value', 'selectData', 'parseInfo'])
const modelValue = useVModel(props, 'value', emit)
const firstInit = ref(false) // 第一次初始化
const totalPage = ref(0) // 总页数
const queryForm = ref<{
  customerName?: string
  pageNumber: number
  pageSize: number
}>({
  pageNumber: 1,
  pageSize: 5
}) // 分页参数
const placeholderSearch = computed(() => '请输入或选择客户名称')
const changeTrim = () => {
  if (typeof modelValue.value === 'string' && props.value?.trim) {
    modelValue.value = modelValue.value?.trim()
  }
}
const parseCustomerInfo = (parseResult: any) => {
  emit('parseInfo', parseResult)
}
const getCustomerList = () => {
  if (!searchValue.value.trim()) {
    return
  }
  getCustomerMethod[props.appId]({
    ...queryForm.value,
    appId: props.appId,
    customerName: searchValue.value
  }).then(({ data }) => {
    // 分页数据合并
    customerEnum.value = customerEnum.value.concat(data.items || [])
    totalPage.value = data.totalPage

    const findIndex = customerEnum.value.findIndex((item: any) => item.value && item.value === 'more')
    if (findIndex !== -1 && !firstInit.value) customerEnum.value.splice(findIndex, 1)
    if (customerEnum.value.length > 0 && data.totalPage > customerEnum.value.length) {
      customerEnum.value.push({
        label: '更多...',
        value: 'more'
      })
    }
    // 当 disabled 为 false 时,修改 firstInit 状态，否则每次都当作是首次初始化
    if (!props.disabled) firstInit.value = false
  })
}
const highlightMatch = (text: string, keyword: string) => {
  if (!keyword) {
    return text
  }
  const regex = new RegExp(`(${keyword})`, 'gi')
  return text.replace(regex, '<span style="color: #1d4cd2">$1</span>')
}
// watch(modelValue, async (newValue, oldValue) => {
//   if (newValue) {
//     searchValue.value = newValue.trim()
//     customerEnum.value = []
//     queryForm.value.pageNumber = 1
//     await getCustomerList()
//   }
//   // 监听 clear 清空
//   if (newValue == null && oldValue) {
//     customerEnum.value = []
//     searchValue.value = ''
//   }
// }, { immediate: true }
// )
const onSelect: SelectProps['onChange'] = (v: any) => {
  searchValue.value = v.trim()
  customerEnum.value = []
  queryForm.value.pageNumber = 1
  getCustomerList()
  emit('selectData', v)
  emit('update:value', v)
}
const moreAction = () => {
  queryForm.value.pageNumber++
  getCustomerList()
}
const handleSearch = debounce((val: string) => {
  searchValue.value = val.trim()
  customerEnum.value = []
  queryForm.value.pageNumber = 1
  getCustomerList()
}, 500)
</script>
<script lang="ts">
export default { name: 'CosInputTianyancha' }
</script>

<style lang="scss" scoped>

.tag {
  padding: 5px 10px;
  color: white;
  border-radius: 5px;
  background-color: $Primary;
}

</style>
